import { formatDistanceToNow } from 'date-fns';

export const formatRelativeDate = (date: Date | string | undefined): string => {
  if (!date) {
    return 'Never';
  }

  return formatDistanceToNow(new Date(date), { addSuffix: true });
};
